const ultimateElement = document.querySelectorAll('.wt-Ultimate');
window.fireOnVisible(ultimateElement, async () => {
    await import('./assets/css/wt-Ultimate.scss');
});

const ultimateE_DirectoryListLink = document.querySelectorAll('.swt-Ultimate_DirectoryListLink');
window.fireOnVisible(ultimateElement, async () => {
    ultimateE_DirectoryListLink.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            let target = document.querySelector(e.target.hash);
            window.scrollToTarget(target);
        });
    });
});

const widgetPlugins = window.TCMS.widgetsSubPlugins || {};
const uPlugins = widgetPlugins.Ultimate || [];

if (uPlugins.length > 0) {
    for (const uPlugin of uPlugins) {
        import(`./plugins/${uPlugin}/plugin.import.js`).catch((err) => {
            console.log(uPlugin + ' loading error');
            console.error(err);
        });
    }
}
